import HtmlParser from "html-react-parser";
import styled from "styled-components";

import { DAVYS_GREY_700, MOSS_GREEN_800 } from "./colors";
import FlexBox from "./FlexBox";
import { Body1, Body2, } from "./Headings";

const Container = styled(FlexBox)`
  width: 100%;
  height: 100%;
  padding: 2.5rem;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 768px) {
    padding: 1.5rem;
  }
`;

const Content = styled(FlexBox)`
  flex-direction: column;
  max-width: ${({ contentWidth }) => contentWidth};
  row-gap: 0.5rem;
  align-items: center;
`;

const NullStateImg = styled.img`
  width: ${({ imgWidth }) => imgWidth || "10rem"};
  height: ${({ imgHeight }) => imgHeight || "10rem"};
`;

const BtnWrapper = styled.div`
  margin-top: 1rem;
`;

const Subtext = styled(Body2)`
  .link,
  a {
    text-decoration: underline;
    color: ${MOSS_GREEN_800};
    font-weight: 700;
  }
`;

const NullState = ({
  imgSrc,
  imgWidth,
  imgHeight,
  text,
  contentWidth = "30rem",
  subtext = "",
  customSubtext = null,
  Button = null,
  rowGap = "2.5rem",
}) => {
  return (
    <Container>
      <FlexBox column rowGap={rowGap} align="center">
        {imgSrc && (
          <NullStateImg
            src={imgSrc}
            imgWidth={imgWidth}
            imgHeight={imgHeight}
            alt="Null State"
            draggable={false}
          />
        )}
        <Content contentWidth={contentWidth}>
          <Body1 bold color={DAVYS_GREY_700} textAlign="center">
            {text}
          </Body1>
          {subtext && (
            <Subtext color={DAVYS_GREY_700} textAlign="center">
              {HtmlParser(subtext)}
            </Subtext>
          )}
          {customSubtext && (
            <Subtext color={DAVYS_GREY_700} textAlign="center">
              {customSubtext}
            </Subtext>
          )}
          {Button && <BtnWrapper>{Button}</BtnWrapper>}
        </Content>
      </FlexBox>
    </Container>
  );
};

export default NullState;
